import React from "react";
import ArtistFilter from "components/filters/Filters/ArtistFilter";
import ContactFitler from "components/filters/Filters/ContactFilter";
import ProductionFilter from "components/filters/Filters/ProductionFilter";
import VenueFilter from "components/filters/Filters/VenueFilter";
import AppointmentPhaseFilter from "components/filters/Filters/AppointmentPhaseFilter";
import AppointmentTypeFilter from "components/filters/Filters/AppointmentTypeFilter";
import QuarterFilter from "components/filters/Filters/QuarterFilter";

interface QuarterFilterProps {
  external?: boolean;
}

export const QuarterFilters = (props: QuarterFilterProps) => {
  return <>
    <ArtistFilter />
    {!props.external && <ContactFitler />}
    <ProductionFilter />
    {(site.currentEnvironment.venueFilterInMonthViewEnabled && site.permissions.addressBook.canAccess) && <VenueFilter />}
    <AppointmentPhaseFilter />
    <AppointmentTypeFilter />
    <QuarterFilter />
  </>;
};
